import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'nk-company-analysis-risk-layout',
  imports: [],
  templateUrl: './company-analysis-risk-layout.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompanyAnalysisRiskLayoutComponent {
  public bgColor = input.required<string>();
  public printVersion = input(false);
}
